import { render, staticRenderFns } from "./Modal-infos.vue?vue&type=template&id=31103de4&"
import script from "./Modal-infos.vue?vue&type=script&lang=js&"
export * from "./Modal-infos.vue?vue&type=script&lang=js&"
import style0 from "./Modal-infos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports